import React, { forwardRef, useEffect, useState, useRef } from "react";
import {
  Form,
  Row,
  Col,
  Input,
  Select,
  Radio,
  Upload,
  Button,
  Spin,
} from "antd";
import axios from "axios";
import API from "@/api";
import { PlusOutlined } from "@ant-design/icons";

function MxbsFormDetail(props, ref) {
  const formRef = useRef();
  const { userInfo, type, types, selectedRow } = props;
  const [detail, setDetail] = useState({});
  const [spinning, setSpinning] = useState(true);
  const layout = {
    labelCol: {
      span: 8,
      style: { textAlign: "right", whiteSpace: "normal" },
    },
    wrapperCol: {
      span: 16,
    },
  };

  useEffect(() => {
    if (type === "edit" || type === "see" || type === "check") {
      axios.get(API.mxbsDetail + `?id=${selectedRow?.id}`).then((res) => {
        const data = res?.data?.result?.data;
        setDetail(data);
        setSpinning(false);
      });
    } else {
      setSpinning(false);
    }
  }, []);

  if (ref) {
    ref.current = {
      getValue: () => {
        return {
          ...formRef.current?.getFieldsValue(),
        };
      },
      verify: async () => {
        try {
          return await formRef.current.validateFields();
        } catch {
          return Promise.reject();
        }
      },
    };
  }

  return (
    <Spin spinning={spinning}>
      {!spinning ? (
        <Form
          ref={formRef}
          style={{
            padding: "25px 0",
          }}
          initialValues={
            type === "add"
              ? {
                  userCode: userInfo?.code,
                  userName: userInfo?.name,
                  orgName: userInfo?.orgs?.[0]?.name,
                  phone: userInfo?.phone,
                  email: userInfo?.email,
                }
              : {
                  ...detail,
                  status: detail?.status * 1 === 1 ? "" : detail?.status,
                }
          }
        >
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Form.Item {...layout} label="工号" name="userCode">
                <Input disabled />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...layout} label="姓名" name="userName">
                <Input disabled />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...layout} label="单位" name="orgName">
                <Input disabled />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                {...layout}
                label="联系方式"
                rules={[
                  {
                    pattern: /^1[3456789]\d{9}$/,
                    message: "请输入有效的手机号",
                  },
                ]}
                name="phone"
              >
                <Input disabled={type === "add" ? false : true} />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                labelCol={{
                  span: 4,
                }}
                label="邮箱"
                rules={[
                  {
                    type: "email",
                  },
                ]}
                name="email"
              >
                <Input disabled={type === "add" ? false : true} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                rules={[
                  {
                    required: true,
                    message: "请填写模型名称",
                  },
                ]}
                {...layout}
                label="模型名称"
                name="name"
              >
                <Input disabled={type === "add" ? false : true} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                rules={[
                  {
                    required: true,
                    message: "请选择模型类型",
                  },
                ]}
                {...layout}
                label="模型类型"
                name="category"
              >
                <Select
                  options={types}
                  allowClear
                  disabled={type === "add" ? false : true}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                rules={[
                  {
                    required: true,
                    message: "请填写模型格式",
                  },
                ]}
                {...layout}
                label="模型格式"
                name="modelFormat"
              >
                <Input disabled={type === "add" ? false : true} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                rules={[
                  {
                    required: true,
                    message: "请填写精度/量化格式",
                  },
                ]}
                {...layout}
                label="精度/量化格式"
                name="quantFormat"
              >
                <Input disabled={type === "add" ? false : true} />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item {...layout} label="上下文长度" name="context">
                <Input
                  suffix={<>{"（K）"}</>}
                  disabled={type === "add" ? false : true}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...layout} label="参数规模" name="paramSize">
                <Input
                  suffix={<>{"（B）"}</>}
                  disabled={type === "add" ? false : true}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...layout} label="模型文件类型" name="fileType">
                <Input disabled={type === "add" ? false : true} />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item {...layout} label="模型文件路径" name="filePath">
                <Input disabled={type === "add" ? false : true} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...layout} label="模型下载URL" name="downloadUrl">
                <Input disabled={type === "add" ? false : true} />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item {...layout} label="模型大小" name="modelSize">
                <Input
                  suffix={<>{"（GB）"}</>}
                  disabled={type === "add" ? false : true}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...layout} label="推理后端" name="inferenceBackend">
                <Input disabled={type === "add" ? false : true} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...layout} label="GPU数量" name="gpuCount">
                <Input disabled={type === "add" ? false : true} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...layout} label="显存大小" name="memSize">
                <Input
                  suffix={<>{"（GB）"}</>}
                  disabled={type === "add" ? false : true}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...layout} label="部署副本数" name="deployCount">
                <Input disabled={type === "add" ? false : true} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...layout} label="最大并发数" name="maxConcurrent">
                <Input disabled={type === "add" ? false : true} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...layout} label="模型来源" name="modelSource">
                <Input disabled={type === "add" ? false : true} />
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item
                labelCol={{
                  span: 4,
                }}
                label="说明"
                name="remark"
              >
                <Input.TextArea
                  autoSize={{
                    minRows: 3,
                    maxRows: 6,
                  }}
                  disabled={type === "add" ? false : true}
                />
              </Form.Item>
            </Col>
            {type === "check" || type === "see" ? (
              <>
                <Col span={24}>
                  <Form.Item
                    labelCol={{
                      span: 4,
                    }}
                    label="审核状态"
                    name="status"
                    rules={[
                      {
                        required: true,
                        message: "请选择审核状态",
                      },
                    ]}
                  >
                    <Radio.Group
                      options={[
                        {
                          label: "通过",
                          value: 2,
                        },
                        {
                          label: "驳回",
                          value: 3,
                        },
                      ]}
                      disabled={type === "see" ? true : false}
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    labelCol={{
                      span: 4,
                    }}
                    label="审核意见"
                    name="auditOpinion"
                  >
                    <Input.TextArea
                      autoSize={{
                        minRows: 3,
                        maxRows: 6,
                      }}
                      disabled={type === "see" ? true : false}
                    />
                  </Form.Item>
                </Col>
              </>
            ) : undefined}
          </Row>
        </Form>
      ) : undefined}
    </Spin>
  );
}

export default forwardRef(MxbsFormDetail);
